import React from "react";
import { CheckCircle2 } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";
import Reveal from "../Reveal";

export default function ProblemList({ content }) {
  const { t } = useLanguage();
  const items = [
    { title: content?.problem_1_title, desc: content?.problem_1_desc },
    { title: content?.problem_2_title, desc: content?.problem_2_desc },
    { title: content?.problem_3_title, desc: content?.problem_3_desc },
  ].filter((x) => x.title);

  return (
    <section data-testid="problems-section" className="bg-cream py-section sm:py-section-lg border-t border-mist">
      <div className="container-page">
        <Reveal as="div" className="max-w-2xl">
          <span className="eyebrow"><span className="h-1 w-1 rounded-full bg-gold" />{content?.problems_eyebrow || t("service.problems_eyebrow")}</span>
          <h2 className="mt-5 font-display text-display-2 font-semibold text-ink">
            {content?.problems_title || t("service.problems_title")}
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-5 sm:grid-cols-3">
          {items.map((p, i) => (
            <Reveal as="div" key={i} delay={i * 0.08}
              className="rounded-2xl bg-white border border-mist p-7 hover:border-gold/40 transition-colors duration-500"
              data-testid={`problem-card-${i + 1}`}
            >
              <CheckCircle2 className="h-5 w-5 text-gold" strokeWidth={1.5} />
              <h3 className="mt-5 font-display text-h3 font-semibold text-ink leading-snug">
                {p.title}
              </h3>
              <p className="mt-2.5 text-sm text-ink/65 leading-relaxed">{p.desc}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
